import { render, staticRenderFns } from "./EmploymentDetails.vue?vue&type=template&id=3d24f674&scoped=true"
import script from "./EmploymentDetails.vue?vue&type=script&lang=js"
export * from "./EmploymentDetails.vue?vue&type=script&lang=js"
import style0 from "./EmploymentDetails.vue?vue&type=style&index=0&id=3d24f674&prod&scoped=true&lang=css"
import style1 from "./EmploymentDetails.vue?vue&type=style&index=1&id=3d24f674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24f674",
  null
  
)

export default component.exports